import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import _ from 'lodash';

import useDispensary from 'src/dispensary/hooks/use-dispensary';

import Menu from 'components/menu';
import { AmplitudeEvents, useAmplitude } from 'shared/hooks/use-amplitude';
import useStores from 'shared/hooks/use-stores';
import { useGetProductsByBrand } from 'src/dispensary/hooks/use-get-products-by-brand';

export default function CoreMenuBrandsPage() {
  const { dispensary } = useDispensary();
  const { query } = useRouter();

  const { products, loading, totalCount, totalPages } = useGetProductsByBrand(query?.brandId);

  const amplitude = useAmplitude();
  const { UI } = useStores();

  useEffect(() => {
    if (!_.isEmpty(dispensary?.id)) {
      amplitude.log(AmplitudeEvents.menu.viewBrand, {
        dispensaryId: dispensary?.id,
        dispensaryName: dispensary?.name,
        menuVariant: UI.analyticsMenuVariant,
      });
    }
    // rationale: exhaustive deps cause these events to be fired more than we want
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispensary?.id]);

  if (!dispensary) {
    return null;
  }

  return (
    <Menu
      products={products}
      loading={loading}
      dispensary={dispensary}
      totalCount={totalCount}
      totalPages={totalPages}
      page='brands'
    />
  );
}
